import { gql } from './apollo';

export const GET_USER_BY_USERNAME = gql`
    query ($username: MultiTypeInput!) {
        table(
            name: "propertyuser__c"
            columns: ["id", "name", "role__c", "sfid", "username__c"]
            filter: [{ left: "username__c", expression: "=", right: $username }]
            limit: 1
        )
    }
`;

export const GET_USER_BY_USERNAME_CASE_INSENSITIVE = gql`
    query ($username: MultiTypeInput!) {
        table(
            name: "propertyuser__c"
            columns: ["id", "name", "role__c", "sfid", "username__c"]
            filter: [{ left: "username__c", right: $username, expression: "iLike" }]
            limit: 1
        )
    }
`;

export const GET_USERS = gql`
    query (
        $offset: Int = 0
        $limit: Int = 10
        $orderBy: String = "name"
        $orderByDirection: GraphQLDirection = ASC
        $filter: MultiTypeInput = "%"
    ) {
        table(
            name: "propertyuser__c"
            columns: ["id", "name", "role__c", "sfid", "username__c", "inactive", "last_login"]
            filter: [
                { left: "isdeleted", right: "false", expression: "=" }
                {
                    or_: [
                        { left: "name", right: $filter, expression: "iLIKE" }
                        { left: "username__c", right: $filter, expression: "iLIKE" }
                    ]
                }
            ]
            offset: $offset
            limit: $limit
            orderBy: $orderBy
            orderByDirection: $orderByDirection
        )
    }
`;

export const UPDATE_USER = gql`
    mutation (
        $id: String!
        $name: MultiTypeInput
        $email: MultiTypeInput
        $inactive: MultiTypeInput
        $role: MultiTypeInput
        $date: MultiTypeInput
    ) {
        updateRow(
            table: "propertyuser__c"
            id: $id
            values: [
                { property: "name", value: $name }
                { property: "username__c", value: $email }
                { property: "inactive", value: $inactive }
                { property: "role__c", value: $role }
                { property: "systemmodstamp", value: $date }
            ]
        )
    }
`;

export const UPDATE_USER_LAST_LOGIN = gql`
    mutation ($id: String!, $last_login: MultiTypeInput) {
        updateRow(
            table: "propertyuser__c"
            id: $id
            values: [{ property: "last_login", value: $last_login }]
        )
    }
`;

export const DELETE_USER = gql`
    mutation ($id: String!, $date: MultiTypeInput, $email: MultiTypeInput) {
        updateRow(
            table: "propertyuser__c"
            id: $id
            values: [
                { property: "isdeleted", value: true }
                { property: "systemmodstamp", value: $date }
                { property: "username__c", value: $email }
            ]
        )
    }
`;

export const HARD_DELETE_USER = gql`
    mutation ($id: String!) {
        deleteRow(table: "propertyuser__c", id: $id)
    }
`;
